export default function () {
  this.existsRegister('/v1/professional/steps/rules/status', (data, meta) => {
    if (!data.agendas) {
      this.statusAgenda = data.agendas
      this.show = true
    }
    if (data.agendas) {
      this.statusAgenda = data.agendas
      this.show = false
    }
  })
}



// WEBPACK FOOTER //
// ./src/app/professional/agenda/rules/resources/mounted.js